<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-input placeholder="ID/会员名/姓名/手机号码" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-select v-model="type" slot="prepend" placeholder="筛选条件">
                      <el-option label="会员ID"   value="1"></el-option>
                      <el-option label="会员名" value="2"></el-option>
                      <el-option label="姓名" value="3"></el-option>
                      <el-option label="手机" value="4"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="id"
        label="会员ID"
        >
      </el-table-column>
      <el-table-column
        prop="username"
        label="会员名">
      </el-table-column>
      <el-table-column
        prop="realname"
        label="真实姓名">
      </el-table-column>
      <el-table-column
        prop="levelname"
        label="级别">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope"> 
          <el-tag type="success" v-if="scope.row.status==1">正常</el-tag> <el-tag type="info" v-if="scope.row.status==2">拉黑</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="加入时间">
      <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}
      </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
          <el-button type="primary" @click="handleLook(scope.row.id)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        type:'',
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        }
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/user/getUserList",{pageinfo:this.pageinfo,keywords:this.keywords,type:this.type}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.userlist
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      handleLook(userid){
         this.$go("/userinfo?userid="+userid)
      }
  }
}
</script>

<style scoped lang="scss">
.order-detail {font-size:14px;}
.order-detail li{padding: 0.1rem;list-style-type:none;border-bottom: 1px dashed #ccc;}
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
</style>
